import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  eyebrow?: React.ReactNode;
  actions?: React.ReactNode;
  tabs?: React.ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  eyebrow,
  actions,
  tabs,
  className = '',
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          {eyebrow && (
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
              {eyebrow}
            </p>
          )}
          <h1
            className={`${eyebrow ? 'mt-1 ' : ''}text-2xl sm:text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100`}
          >
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div
            role="group"
            aria-label="Page actions"
            className="flex flex-wrap items-center gap-2 sm:justify-end"
          >
            {actions}
          </div>
        )}
      </div>
      {tabs && <div className="mt-4 w-full">{tabs}</div>}
    </div>
  );
};

export default PageHeader;
